import { render, staticRenderFns } from "./tooltip.vue?vue&type=template&id=64803c85&scoped=true"
import script from "./tooltip.vue?vue&type=script&lang=js"
export * from "./tooltip.vue?vue&type=script&lang=js"
import style0 from "./tooltip.vue?vue&type=style&index=0&id=64803c85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64803c85",
  null
  
)

export default component.exports